/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
  $(document).on('change','.Linklist__Item input',function(){
    let inputValue = $(this).val();
    // console.log('changed')
    setTimeout(function(){
      /* if(inputValue == 'XS/S'){
        $('.Block-column input[value="S"]').trigger('click')
      }
      else if(inputValue == 'M/L'){
        $('.Block-column input[value="L"]').trigger('click')
      }
      else if(inputValue == 'XL/XX'){
        $('.Block-column input[value="XXL"]').trigger('click')
      }
      else*/ if(inputValue == 'XXL'){
        $('.Linklist__Item input[value="XL/XX"]').trigger('click')
      }
      else if(inputValue == 'S'){
        $('.Linklist__Item input[value="XS/S"]').trigger('click')
      }
      else if(inputValue == 'L'){
        $('.Linklist__Item input[value="M/L"]').trigger('click')
      }
    },1500)
  });


if ($(window).width() <= 540) { 
  new Flickity('.template-product .ProductList.ProductList--grid ').destroy();
  $carousel.flickity('resize');
}
  

  
});
